export const ATKOMST_URL = "https://api.ingka.ikea.com/auth-service";
export const FIXA_SERVICE_NAME = "FIXA";
